import { render, staticRenderFns } from "./SfcPropAccounts.vue?vue&type=template&id=56aa1c85&"
import script from "./SfcPropAccounts.vue?vue&type=script&lang=js&"
export * from "./SfcPropAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports